export default function sort( array, sortBy ) {
    return array.sort( ( a, b ) => {
        if ( typeof a[ sortBy ] === 'string' ) {
            return a[ sortBy ].localeCompare( b[ sortBy ], undefined, { sensitivity: 'base' } );
        }

        if ( !a[ sortBy ] && !b[ sortBy ] ) {
            return 0;
        }

        if ( !a[ sortBy ] && a[ sortBy ] !== 0 ) {
            return 1;
        }

        if ( !b[ sortBy ] && b[ sortBy ] !== 0 ) {
            return 0;
        }

        a[ sortBy ] = a[ sortBy ] || 0;
        b[ sortBy ] = b[ sortBy ] || 0;
        return a[ sortBy ] - b[ sortBy ];
    } );
}
